import DescriptionSection from './DescriptionSection.view';

export default DescriptionSection;
